module.exports = __webpack_public_path__ + "img/project-inspections-remaining.81e465f2.svg";